import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { LabeledInput, Button } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import { __ } from '../../Utils';
import { connect } from '../../Store';
import ErrorMessage from '../ErrorMessage';

const Wrapper = styled.div``;

const ContentWrapper = styled.div`
  width: 90%;
  flex-direction: column;
  display: flex;
  justify-content: start;
  padding-top: ${rem(20)};
`;

const InputWrapper = styled.div`
  padding: ${rem(10)};
`;

const ButtonWrapper = styled.div`
  padding: ${rem(10)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

class AddNewAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      street: '',
      postal_code: '',
      city: '',
      country: '',
      contact_person: '',
      phone: this.props.firm === 'SK' ? '+421' : '+420',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { addressToEdit } = nextProps;
    this.setState({
      _id: addressToEdit._id,
      name: addressToEdit.name ? addressToEdit.name : '',
      street: addressToEdit.street ? addressToEdit.street : '',
      postal_code: addressToEdit.postal_code ? addressToEdit.postal_code : '',
      city: addressToEdit.city ? addressToEdit.city : '',
      country: addressToEdit.country ? addressToEdit.country : '',
      contact_person: addressToEdit.contact_person
        ? addressToEdit.contact_person
        : '',
      phone: addressToEdit.phone
        ? addressToEdit.phone
        : this.props.firm === 'SK'
        ? '+421'
        : '+420',
    });
  }

  onSubmit() {
    const { onAdd } = this.props;
    const {
      _id,
      name,
      street,
      postal_code,
      city,
      country,
      contact_person,
      phone,
    } = this.state;

    if (this.checkData()) {
      onAdd({
        _id,
        name,
        street,
        postal_code,
        city,
        country,
        contact_person,
        phone,
      });
    }
  }

  handleChange(type, value) {
    let {
      name,
      street,
      postal_code,
      city,
      country,
      contact_person,
      phone,
      error,
    } = this.state;

    if (error) {
      this.setState({
        company_nameError: false,
        streetError: false,
        postal_codeError: false,
        cityError: false,
        countryError: false,
        contact_personError: false,
        phoneError: false,
        error: false,
      });
    }

    if (type === 'company_name') {
      name = value;
    } else if (type === 'street') {
      street = value;
    } else if (type === 'postal_code') {
      if (
        Number(value.replace(/\s/g, '')) > 0 ||
        value.length === 0 ||
        value === '0'
      ) {
        postal_code = value;
      }
    } else if (type === 'city') {
      city = value;
    } else if (type === 'country') {
      country = value;
    } else if (type === 'contact_person') {
      contact_person = value;
    } else if (type === 'phone') {
      if (Number(value.replace(/\s/g, '')) && value.length > 3) {
        phone = value;
      }
    }

    this.setState({
      name,
      street,
      postal_code,
      city,
      country,
      contact_person,
      phone,
    });
  }

  checkData() {
    const {
      name,
      street,
      postal_code,
      city,
      country,
      contact_person,
      phone,
    } = this.state;

    let {
      company_nameError,
      streetError,
      postal_codeError,
      cityError,
      countryError,
      contact_personError,
      phoneError,
    } = this.state;

    let isValid = true;

    if (name.length < 1) {
      company_nameError = true;
      isValid = false;
    }
    if (street.length < 1) {
      streetError = true;
      isValid = false;
    }
    if (postal_code.length < 4) {
      postal_codeError = true;
      isValid = false;
    }
    if (city.length < 1) {
      cityError = true;
      isValid = false;
    }
    if (country.length < 1) {
      countryError = true;
      isValid = false;
    }
    if (contact_person.length < 1) {
      contact_personError = true;
      isValid = false;
    }
    if (phone.length < 10) {
      phoneError = true;
      isValid = false;
    }

    this.setState({
      company_nameError,
      streetError,
      postal_codeError,
      cityError,
      countryError,
      contact_personError,
      phoneError,
      error: !isValid && __('Nevyplenené povinné hodnoty'),
    });

    return isValid;
  }

  render() {
    const {
      name,
      street,
      postal_code,
      city,
      country,
      contact_person,
      phone,
      company_nameError,
      streetError,
      postal_codeError,
      cityError,
      countryError,
      contact_personError,
      phoneError,
      error,
    } = this.state;
    return (
      <Wrapper>
        <ContentWrapper>
          <ErrorMessage display={error} text={error} />
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('company_name', e.target.value)}
              style={{ width: rem(300) }}
              labelText={__('Meno / Firma')}
              placeholder={__('Meno / Firma')}
              value={name}
              error={company_nameError}
            />
          </InputWrapper>
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('street', e.target.value)}
              style={{ width: rem(300) }}
              labelText={__('Ulica')}
              placeholder={__('Ulica')}
              value={street}
              error={streetError}
            />
          </InputWrapper>
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('postal_code', e.target.value)}
              style={{ width: rem(300) }}
              labelText={__('PSČ')}
              placeholder={__('PSČ')}
              value={postal_code}
              error={postal_codeError}
            />
          </InputWrapper>
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('city', e.target.value)}
              style={{ width: rem(300) }}
              labelText={__('Mesto')}
              placeholder={__('Mesto')}
              value={city}
              error={cityError}
            />
          </InputWrapper>
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('country', e.target.value)}
              style={{ width: rem(300) }}
              labelText={__('Krajina')}
              placeholder={__('Krajina')}
              value={country}
              error={countryError}
            />
          </InputWrapper>
          <InputWrapper>
            <LabeledInput
              onChange={e =>
                this.handleChange('contact_person', e.target.value)
              }
              style={{ width: rem(300) }}
              labelText={__('Kontaktná osoba')}
              placeholder={__('Kontaktná osoba')}
              value={contact_person}
              error={contact_personError}
            />
          </InputWrapper>
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('phone', e.target.value)}
              style={{ width: rem(300) }}
              labelText={__('Mobil')}
              placeholder={__('Mobil')}
              value={phone}
              error={phoneError}
            />
          </InputWrapper>
          <ButtonWrapper>
            {this.props.addressToEdit._id ? (
              <Button onClick={() => this.onSubmit()} primary>
                {__('Upraviť adresu')}
              </Button>
            ) : (
              <Button onClick={() => this.onSubmit()} primary>
                {__('Pridať adresu')}
              </Button>
            )}
          </ButtonWrapper>
        </ContentWrapper>
      </Wrapper>
    );
  }
}

AddNewAddress.propTypes = {
  addressToEdit: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    postal_code: PropTypes.number,
    country: PropTypes.string,
    contact_person: PropTypes.string,
    phone: PropTypes.number,
  }),
  firm: PropTypes.string,
};

AddNewAddress.defaultProps = {
  addressToEdit: {
    _id: '',
    name: '',
    street: '',
    postal_code: '',
    city: '',
    country: '',
    contact_person: '',
    phone: '+421',
  },
  firm: 'SK',
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(AddNewAddress);



// WEBPACK FOOTER //
// ./src/Components/AddNewAddress/index.jsx